module.exports = {"TXTWCL_Convert_Funds":{"id":"TXTWCL_Convert_Funds","defaultMessage":"Veksl penge","track":"Convert Funds"}}